import cn from 'classnames';
import { useMemo, useState } from 'react';

type ResultItemImageProps = {
    imageUrl: string | undefined;
    loading?: 'eager' | 'lazy';
};

const applyImageRule = (url: string | undefined, rule: string) => {
    if (!url) return url;
    return url.replace('/default/', rule);
};

export const ResultItemImage = ({ imageUrl, loading = 'lazy' }: ResultItemImageProps) => {
    const [hasError, setHasError] = useState(!imageUrl);

    const src = useMemo(() => applyImageRule(imageUrl, '/320x240c/'), [imageUrl]);

    return (
        <img
            src={src}
            alt=""
            loading={loading}
            fetchPriority={loading === 'eager' ? 'high' : undefined}
            decoding={loading === 'eager' ? 'sync' : 'async'}
            width={320}
            height={240}
            onError={() => setHasError(true)}
            className={cn('h-144 w-full', { 's-bg-active border': hasError, 'object-cover': !hasError })}
        />
    );
};
